module.exports = __webpack_public_path__ + "img/item-shields-03.efb5be88.png";